import Model, { attr, belongsTo, hasMany } from '@ember-data/model';
import type AccountingPaymentModel from './accounting-payment.ts';
import type AccountingTransactionModel from './accounting-transaction.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class BulkAchPaymentModel extends Model {
  @attr declare creditor: string;
  @attr declare totalAmount: number;
  @attr declare transactionCount: number;
  @attr declare rosterFileS3Path: string;
  @attr declare state: string;
  @attr declare settlementDate: string;

  /*************************
   **  Relationships      **
   *************************/

  @belongsTo('accounting-payment', { async: false, inverse: null })
  declare accountingPayment: AccountingPaymentModel;

  @hasMany('accounting-transaction', { async: false, inverse: null })
  declare accountingTransactions: AccountingTransactionModel[];

  [Type] = 'bulk-ach-payment' as const;
}
